import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatAddedToSpaceHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const text = presenter.isChannel
    ? t('space_channel_added', { 0: presenter.spaceName, interpolation: { escapeValue: false } })
    : t('space_group_added', { 0: presenter.spaceName, interpolation: { escapeValue: false } });

  return { html: text };
};
